<section role="region" class="wrapper--gradient">
  <div class="container">
    <header role="banner" class="cej-hero__header">
      <h1 class="cej-hero__header__title">Je découvre le Contrat d&apos;Engagement Jeune</h1>
      <button
        type="button"
        class="btn cej-hero__header__btn"
        [class.btn--white]="(isMobileAndTabletPortrait$ | async) === false"
        [class.cej-hero__header__btn--dark]="(isMobileAndTabletPortrait$ | async) === false"
        (click)="heroButtonClicked()"
      >
        Je me lance
        <mat-icon svgIcon="chevron_right" role="presentation"></mat-icon>
      </button>
    </header>

    <img
      *ngIf="(isMobile$ | async) === false"
      alt=""
      [src]="heroSrc | imaginarySrc: 1:837"
      [srcset]="heroSrc | imaginarySrc: 4:837"
    />
    <ng-container *ngIf="(isMobile$ | async) === true">
      <img alt="" [src]="heroMobileSrc1 | imaginarySrc: 1:837" [srcset]="heroMobileSrc1 | imaginarySrc: 4:837" />
      <p class="bg-img-mobile">
        <img alt="" [src]="heroMobileSrc2 | imaginarySrc: 1:837" [srcset]="heroMobileSrc2 | imaginarySrc: 4:837" />
      </p>
    </ng-container>
  </div>
</section>
